import {
  GETALL_DOCUMENTOS,
  LOADING_GETALL_DOCUMENTOS,
  ACTIVO_DOCUMENTOS,
  SET_LOGOUT,
  CLEAR_ALL,
  PARAMS_DOCUMENTOS,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const documentosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_DOCUMENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_DOCUMENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_DOCUMENTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_DOCUMENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
